import type { UnitCircleWidgetConfig } from '../unit-circle.model';

export const UNIT_CIRCLE_TRIG_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-trig',
  type: 'unit-circle',
  params: {
    point: { angle: '\\pi/4' },
    trigLines: { lines: ['sin', 'cos', 'tan', 'sec', 'csc', 'cot'], referenceTriangle: true },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2.5, xEnd: 2.5, yStart: -2.5, yEnd: 2.5 },
      grid: { type: 'lines', visible: true },
    },
  },
};
